import { render, staticRenderFns } from "./LawDailyworkDescriptionForm.vue?vue&type=template&id=65aab749&"
import script from "./LawDailyworkDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./LawDailyworkDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./LawDailyworkDescriptionForm.vue?vue&type=style&index=0&id=65aab749&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports